if (!customElements.get("purchase-availability")) {

    class PurchaseAvailability extends HTMLElement{
        constructor(){
            super()
            this.sku = this.dataset.sku
            this.clickAndCollectButton = this.querySelector("#click-and-collect-button")
            this.clickAndCollectDrawer = this.querySelector("click-and-collect-drawer")
            this.storeListButton = this.querySelector("#store-list-button")
            this.storeListDrawer = this.querySelector("store-list-drawer")
            this.skeleton = this.querySelector("skeleton")
            this.language = document.body.dataset.language
        }

        connectedCallback(){
            document.body.appendChild(this.clickAndCollectDrawer);
            document.body.appendChild(this.storeListDrawer);

            this.syncButtonEvent()
            this.fetchStores(this.sku)
            this.handleBodyClick()
            this.handleDrawerState()
        }

        syncButtonEvent(){
            this.clickAndCollectButton.addEventListener("click", this.handleClickAndCollectButton.bind(this))
            this.clickAndCollectDrawer.querySelector(".click-and-collect-drawer-button").addEventListener("click",()=>{
                this.clickAndCollectDrawer.removeAttribute("open")
            })
            this.storeListButton.addEventListener("click", this.handleStoreListButton.bind(this))
            this.storeListDrawer.querySelector(".store-list-drawer-button").addEventListener("click",()=>{
                this.storeListDrawer.removeAttribute("open")
            })
        }

        handleClickAndCollectButton(evt){
            this.storeListDrawer.removeAttribute("open")
            this.clickAndCollectDrawer.setAttribute("open", '')
        }

        handleStoreListButton(evt){
            this.clickAndCollectDrawer.removeAttribute("open")
            this.storeListDrawer.setAttribute("open", '')
        }

        async fetchStores(sku){

            this.handlePrefetching()
            const checkClickAndCollectReq = await theme.fetch.request("/pickup-info", "POST", {
                storeName: theme.store.get(),
                data: {
                    productSkus: [sku]
                }
            });
                        
            if (checkClickAndCollectReq.data.result[0][sku]) {
                this.skeleton.classList.add("hidden")
                this.querySelector(".click-and-collect").classList.remove("hidden")
                this.querySelector(".store-availability").classList.remove("hidden")
            }

            const fetchReqRes = await theme.fetch.request("/product-page-info", "POST", {
                "product":{
                    "storeName": theme.store.get(),
                    "productSku": [sku],
                    "pageType": "product"
                }
            });

            this.skeleton.classList.add("hidden")

            if (fetchReqRes?.data.pickupAddress.length > 0) {
                this.handleClickAndCollectDrawerContent(fetchReqRes.data.pickupAddress)
            }
            
            if (fetchReqRes?.data.storeDetails.length > 0) {
                this.querySelector(".store-availability").classList.remove("hidden")
                this.handleStoreAvailabilityDrawerContent(fetchReqRes.data.storeDetails)
            }
        }

        handleClickAndCollectDrawerContent(pickupAddresses){
            const stores = this.generateStores(pickupAddresses)

            this.clickAndCollectDrawer.querySelector(".drawer-body").innerHTML = stores.outerHTML
        }

        handleStoreAvailabilityDrawerContent(storeAddresses){
            const stores = this.generateStores(storeAddresses)

            this.storeListDrawer.querySelector(".drawer-body").innerHTML = stores.outerHTML
        }

        generateStores(stores){
            const ul = document.createElement('ul');
            ul.className = 'store-list list-unstyled';
            ul.setAttribute('role', 'list');

            stores.forEach(store => {
                const li = document.createElement('li');
                li.classList.add('store-address__item');
                li.innerHTML = `
                <h4 class="store-title">${store.store_address.store_name[this.language]}</h4>
                <address class="store-address">
                    <p>
                    ${store.store_address.address_line_2[this.language] || ''}<br/>
                    ${store.store_address.city[this.language] || ''}<br/>
                    ${store.store_address.contact_phone || ''}
                    </p>
                    <p class="timing">
                      <label>${this.dataset.timingTranslate}: </label>
                      <span>${store.store_address.working_hours[this.language]}</span>
                    </p>
                    <p class="location">
                        <a href="${store.store_address.geo_location}" target="_blank" class="direction-link">store direction</a>
                        <span class="direction-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" class="a8x1wuy a8x1wux _1fragem32 _1fragemq0 _1fragemly _1fragemlo _1fragemp6"><path stroke-linejoin="round" d="m7.875 11.697 4.003-8.578c.296-.635-.362-1.293-.997-.997L2.303 6.125c-.453.212-.35.884.146.949l3.385.446a.75.75 0 0 1 .646.646l.446 3.385c.065.495.737.599.949.146"></path></svg>
                        </span>
                    </p>
                </address>`;
                ul.appendChild(li);
            });

            return ul
        }

        handlePrefetching(){
            let skeletons = `
                <skeleton><div class="skeleton-container"><div class="skeleton-header"></div><div class="skeleton-paragraph"></div></div></skeleton>
                <skeleton><div class="skeleton-container"><div class="skeleton-header"></div><div class="skeleton-paragraph"></div></div></skeleton>
                <skeleton><div class="skeleton-container"><div class="skeleton-header"></div><div class="skeleton-paragraph"></div></div></skeleton>
                <skeleton><div class="skeleton-container"><div class="skeleton-header"></div><div class="skeleton-paragraph"></div></div></skeleton>
                <skeleton><div class="skeleton-container"><div class="skeleton-header"></div><div class="skeleton-paragraph"></div></div></skeleton>
                <skeleton><div class="skeleton-container"><div class="skeleton-header"></div><div class="skeleton-paragraph"></div></div></skeleton>
            `
            this.clickAndCollectDrawer.querySelector(".drawer-body").innerHTML = skeletons
            this.storeListDrawer.querySelector(".drawer-body").innerHTML = skeletons

            this.skeleton.classList.remove("hidden")

            this.querySelector(".click-and-collect").classList.add("hidden")
            this.querySelector(".store-availability").classList.add("hidden")
        }

        handleBodyClick(){
            document.addEventListener('click', (evt)=> {
                if (evt.target.closest("click-and-collect-drawer") == null && this.clickAndCollectDrawer.hasAttribute("open") && !evt.target.closest(".product-drawers__item")) {
                    this.clickAndCollectDrawer.removeAttribute("open")
                }

                if (evt.target.closest("store-list-drawer") == null && this.storeListDrawer.hasAttribute("open") && !evt.target.closest(".product-drawers__item")) {
                    this.storeListDrawer.removeAttribute("open")
                }
            });
        }

        handleDrawerState(){
            const targetNodes = document.querySelectorAll("click-and-collect-drawer, store-list-drawer");

            targetNodes.forEach(targetNode => {
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.target.hasAttribute("open")) {
                            document.body.classList.add("overflow-hidden")
                            if (window.innerWidth <= 768) { 
                                document.querySelector("html").classList.add("overflow-hidden")
                            }
                        } else {
                            document.body.classList.remove("overflow-hidden")
                            if (window.innerWidth <= 768) { 
                                document.querySelector("html").classList.remove("overflow-hidden")
                            }
                        }
                    })
                })
                observer.observe(targetNode, { attributes: true })
            })

        }
    }

    customElements.define('purchase-availability', PurchaseAvailability)
}